import $ from 'jquery';
import * as MarkerClusterer from '@google/markerclusterer/dist/markerclusterer.umd.js';
import config from './config';
import loadGoogleMapsApi from '../../utility/load-google-api';
import mapStoreList from './store-list';

let map;
let markerCluster;
const markersArray = [];
let highlight = null;
let googleMaps;

// ICONS

function getDefaultIcon() {
    return {
        url: '/assets/gfx/marker-icon-2x.png',
        scaledSize: new googleMaps.Size(18, 21), // 70 80
        origin: new googleMaps.Point(0, 0),
        anchor: new googleMaps.Point(9, 21)
    };
}

function getHighlightIcon() {
    return {
        url: '/assets/gfx/marker-icon-2x.png',
        scaledSize: new googleMaps.Size(36, 42),
        origin: new googleMaps.Point(0, 0),
        anchor: new googleMaps.Point(18, 42)
    };
}


function configExtend($map, defaultConfig) {
    const domOptions = $map.data();
    const mapOptions = {};

    if (domOptions.country) {
        defaultConfig.country = domOptions.country;
    }

    if (domOptions.zoom) {
        mapOptions.zoom = domOptions.zoom;
    }

    if (typeof (domOptions.latitude && domOptions.longitude) === 'number') {
        mapOptions.center = {
            'lat': domOptions.latitude,
            'lng': domOptions.longitude
        };
    }

    return Object.assign(defaultConfig.mapOptions, mapOptions);
}


function init() {
    // defaultZoom is when a store is selected
    // zoom is whem the map loads and the entrie country is visible
    // debugger;
    const $map = $('#map');
    const mapApiKey = $map.data('key'); // AIzaSyBKs2z_dlOYtJRi_AJyPJcqjPa3D_HftVI

    if ($map.length) {
        configExtend($map, config);
    }

    if ($map.length && mapApiKey) {
        loadGoogleMapsApi({key: mapApiKey}).then((api) => {
            googleMaps = api;
            window.google = window.google || {};
            window.google.maps = api;

            map = new googleMaps.Map(document.getElementById('map'), config.mapOptions);
            map.setOptions({styles: config.mapStyles});

            config.markerDefaultIcon = getDefaultIcon();
            config.markerHighlightIcon = getHighlightIcon();

            fetchStores();

            googleMaps.event.addDomListener(window, 'resize', function () {
                map.setCenter(map.getCenter());
            });
        });
    }
}

function fetchStores() {
    $('.js-store').each(function () {
        const $store = $(this);
        const markerObj = {
            position: {
                lat: parseFloat($store.data('lat')),
                lng: parseFloat($store.data('lng'))
            },
            storeId: $store.data('store'),
            icon: config.markerDefaultIcon,
            filters: $store.data('filters')
        };
        const marker = new googleMaps.Marker(markerObj);
        bindMarker(marker);
        markersArray.push(marker);
    });

    markerCluster = new MarkerClusterer.default(map, markersArray, config.clusterOptions);

    mapStoreList.init();
}

// hide filtered markers
function updateMarkersByFilters(filterKeysArray){
    const arrayForClusters = [];
    markersArray.forEach(function(marker, i){
        const filters = marker.filters.split(' ');
        let valid = false;
        for (let j = 0; j <= filters.length; j++ ){
            if (filterKeysArray.indexOf(filters[j]) != -1) {
                valid = true;
            }
        }
        if (filterKeysArray.length < 1 || valid){
            marker.setVisible(true);
            arrayForClusters.push(marker);
        } else {
            marker.setVisible(false);
        }
    });
    updateClusters(arrayForClusters);
}

function updateClusters(ArrayOfMarkers){
    markerCluster.clearMarkers();
    markerCluster = new MarkerClusterer(map, ArrayOfMarkers, config.clusterOptions);
}

// MAP CONTROLS

function setDefaultView() {
    map.setCenter(config.mapOptions.center);
    map.setZoom(config.mapOptions.zoom);
    removeHighlight();
}

function zoomToBounds(lat1, lng1, lat2, lng2) {
    map.fitBounds([[lat1, lng1], [lat2, lng2]]);
}

function gotoBounds(bounds) {
    let mapoffset = 0;
    const mapWidth = $(map.getDiv()).width();
    if (mapWidth > 665) {
        mapoffset = (mapWidth * 0.12) * -1;
    }
    map.fitBounds(bounds);
    map.panBy(mapoffset, 0);
}

function setMapView(lng, lat, offset, customZoom) {
    const zoom = customZoom || config.defaultZoom;
    let mapoffset = offset || 0;
    const obj = {'lat': lat, 'lng': lng};
    const mapWidth = $(map.getDiv()).width();
    map.panTo(obj);
    map.setZoom(zoom);
    if (mapWidth > 665 && mapoffset == 0) {
        mapoffset = mapWidth * 0.12;
        map.panBy(-mapoffset, 0);
    }
}

// MARKERS

function bindMarker(marker) {
    marker.addListener('click', function () {
        mapStoreList.selectStore(marker.storeId);
        selectMarker(marker);
    });
}

function selectMarker(marker) {
    removeHighlight();
    marker.setIcon(config.markerHighlightIcon);
    highlight = marker;
}

function setMarkerByStoreId(storeID) {
    const marker = getMarkerByStoreId(storeID);
    if (marker && marker.storeId) {
        selectMarker(marker);
    }
}

function getMarkerByStoreId(storeID) {
    for (const m of markersArray) {
        if (m.storeId === storeID) {
            return m;
        }
    }
    return null;
}

function removeHighlight() {
    if (highlight !== null) {
        highlight.setIcon(config.markerDefaultIcon);
        highlight = null;
    }
}

// FIND STORES

function findStoresNearest(coords) {
    return NearestStore(coords.lat, coords.lng, coords.markers ? coords.markers : markersArray);
}

function NearestStore(latitude, longitude, storeMarkersList) {
    const topThree = [];
    for (let index = 0; index < storeMarkersList.length; ++index) {
        const dif = PythagorasEquirectangular(latitude, longitude, storeMarkersList[index].position.lat(), storeMarkersList[index].position.lng());
        topThree.push({
            storeMarker: storeMarkersList[index],
            difference: dif
        });
    }
    topThree.sort(function (a, b) {
        return a.difference - b.difference;
    });
    return topThree.splice(0, 3);
}


/**
 * @return {number}
 */
function Deg2Rad(deg) {
    return deg * Math.PI / 180;
}

/**
 * @return {number}
 */
function PythagorasEquirectangular(lat1, lon1, lat2, lon2) {
    const _lat1 = Deg2Rad(lat1);
    const _lat2 = Deg2Rad(lat2);
    const _lon1 = Deg2Rad(lon1);
    const _lon2 = Deg2Rad(lon2);
    const R = 6371; // km
    const x = (_lon2 - _lon1) * Math.cos((_lat1 + _lat2) / 2);
    const y = (_lat2 - _lat1);
    return Math.sqrt(x * x + y * y) * R;
}

export default {
    init,
    zoomToBounds,
    setMapView,
    setMarkerByStoreId,
    setDefaultView,
    findStoresNearest,
    gotoBounds,
    updateMarkersByFilters
};
